import agent from '../agent'
import {
  TAGS_SUGGESTIONS_LOADED,
  TAGS_SUGGESTIONS_UNLOADED,
  ADD_TAG,
  REMOVE_TAG
} from "../constants/actionTypes"

export const tagsSuggestionsLoaded = (payload) => ({
  type: TAGS_SUGGESTIONS_LOADED,
  payload
});

export const clearTags = () => ({
  type: TAGS_SUGGESTIONS_UNLOADED
})

export const addTag = (payload) => ({
  type: ADD_TAG,
  payload
})

export const removeTag = (payload) => ({
  type: REMOVE_TAG,
  payload
})

export const loadTagsSuggestions = (dispatch) => (term) => {
  agent.Tags.getByName(term).then(res => {
    dispatch(tagsSuggestionsLoaded(res));
  }, err => {
    dispatch(tagsSuggestionsLoaded({
      hasError: true,
      error: err.response.body.responseStatus.message
    }));
  });
}

export const clearTagsList = (dispatch) => () => {
  dispatch(clearTags());
}

export const addNewTag = (dispatch) => (tag) => {
  dispatch(addTag(tag));
}

export const removeCurrentTag = (dispatch) => (tag) => {
  dispatch(removeTag(tag));
}